import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-prantwise-all-total-talukawise-business-report',
  // standalone: true,
  // imports: [],
  templateUrl: './prantwise-all-total-talukawise-business-report.component.html',
  styleUrl: './prantwise-all-total-talukawise-business-report.component.scss'
})
export class PrantwiseAllTotalTalukawiseBusinessReportComponent implements OnInit {


 offrepwiseData;
   today = new Date();
   startDate = '';
   endDate = '';
   isLoading: boolean = false;
   subTypesName = [
     { name: 'वार्षिक', isVisible: false },
     { name: 'त्रैवार्षिक', isVisible: false },
     { name: 'पंचवार्षिक', isVisible: false },
   ];
   totalth = 0;
   finalData = [];
   off_rep_name;
   appliedFilters: any = {};
 
   constructor(
     public dialogref: MatDialogRef<PrantwiseAllTotalTalukawiseBusinessReportComponent>,
     @Inject(MAT_DIALOG_DATA) public data: any, public service: DigisubservicesService,
   ) {}
 
   ngOnInit(): void {
     this.isLoading = true;
     this.offrepwiseData = this.data['offrepwisedata'];
     this.off_rep_name = this.data['off_rep_name'];
     this.startDate = this.data['startDate'];
     this.endDate = this.data['endDate'];
     // console.log(this.offrepwiseData);
     
    this.appliedFilters = this.data['appliedFilters'] || {};
 
    console.log("Applied Filters:", this.appliedFilters);
 
     let data = this.uniqueData(this.offrepwiseData, (a) => a.subscription_type);
 
     for (let i = 0; i < Object.keys(data).length; i++) {
       let flag = false;
       for (let j = 0; j < Object.keys(this.subTypesName).length; j++) {
         if (data[i]['subscription_type'] === this.subTypesName[j]['name']) {
           this.subTypesName[j]['isVisible'] = true;
           flag = true;
           break;
         }
       }
       if (!flag) {
         // if (
         //   data[i]['Subscription_Type'] !== 'हितचिंतक सप्रेम भेट' ||
         //   data[i]['Subscription_Type'] !== 'सप्रेम भेट - संपादकीय विभाग' ||
         //   data[i]['Subscription_Type'] !== 'जाहिरात स. भेट' ||
         //   data[i]['Subscription_Type'] !== 'संघ परिवार सप्रेम भेट' ||
         //   data[i]['Subscription_Type'] !== 'वर्गणी सप्रेम भेट'
         // ) {
         this.subTypesName.push({
           name: data[i]['subscription_type'],
           isVisible: true,
         });
         // }
       }
     }
 
     // console.log(this.subTypesName);
     // this.totalth = this.subTypesName.length * 4 + 8;
 
      this.totalth = this.subTypesName.filter(b => b.isVisible).length * 4 + 34;
 
     // this.getoffdata();
    //  this.setData();
      // ✅ IMPORTANT: CALL EXPENSE API FIRST
  this.loadExpenseData();
  this.getAllVouchersData();
   }

expenseLedgerData: any[] = [];

getallVouchersData: any[] = [];

loadExpenseData() {

  const request = {
    exp_id: 35,
    sub_exp_id: "312",
    startdate: this.startDate,
    enddate: this.endDate
  };

  this.service.getExpenseLedgerReportData(request).subscribe({
    next: (res: any) => {
      this.expenseLedgerData = res || [];
      console.log('EXPENSE Ledger Data:', res);
      this.setData();
    },
    error: () => {
      this.expenseLedgerData = [];
      this.setData();
    }
  });
}

getAllVouchersData() {

  const fyStart = this.startDate;
  const fyEnd = this.endDate;

  this.service.getvoucherbySub(fyStart, fyEnd).subscribe(
    (res: any) => {

      console.log('EXPENSE API RESPONSE:', res);

      // ✅ FIX: handle both cases (array OR object)
      this.getallVouchersData = Array.isArray(res)
        ? res
        : (res?.data || []);

      console.log('FINAL VOUCHER DATA:', this.getallVouchersData);

      this.setData();
    },
    (error: any) => {
      console.error('EXPENSE API ERROR:', error);

      this.getallVouchersData = [];
      this.setData();
    }
  );
}


// एकूण Column Calculation 
// setData() {

//   if (!this.offrepwiseData) return;

//   const NET_TYPES = [
//     'वार्षिक',
//     'त्रैवार्षिक',
//     'पंचवार्षिक',
//     'ऑनलाईन अंक सहामाही',
//     'ऑनलाईन अंक वार्षिक'
//   ];

//   const EXCLUDE_YOJANA = [
//     ...NET_TYPES,
//     'मुदत ठेव (पंचवार्षिक वर्गणीदार)'
//   ];

//   const DEPOSIT_TYPE = 'मुदत ठेव (पंचवार्षिक वर्गणीदार)';

//   const normalize = (val: any) =>
//     (val || '')
//       .toString()
//       .trim()
//       .replace(/\s+/g, ' ')
//       .replace(/[^\w\u0900-\u097F ]/g, '')
//       .toLowerCase();

//   // ================= DONATION =================
//   const allVouchers = (Array.isArray(this.expenseLedgerData) ? this.expenseLedgerData : [])
//     .reduce((acc: any[], exp: any) => {

//       const expName = (exp.exp_name || '').toString();
//       const subExpName = (exp.sub_exp_name || '').toString();

//       const isDonation =
//         expName.includes('देणगी') ||
//         subExpName.includes('वर्गणी विभाग - देणगी');

//       if (isDonation && Array.isArray(exp.vouchers)) {
//         acc.push(...exp.vouchers);
//       }

//       return acc;
//     }, []);

//   const donationMap: any = {};
//   const start = new Date(this.startDate);
//   const end = new Date(this.endDate);

//   allVouchers.forEach((v: any) => {
//     const rep = normalize(v.rep_name);
//     if (!rep) return;

//     const vDate = new Date(v.voucher_date);
//     if (isNaN(vDate.getTime())) return;
//     if (vDate < start || vDate > end) return;

//     if (!donationMap[rep]) {
//       donationMap[rep] = { count: 0, amount: 0 };
//     }

//     donationMap[rep].count += 1;
//     donationMap[rep].amount += Number(v.exp_amt) || 0;
//   });

//   // ================= PENDING =================
//   const pendingMap: any = {};

//   (this.getallVouchersData || []).forEach((v: any) => {
//     const rep = normalize(v.rep_name);
//     if (!rep) return;

//     if (!pendingMap[rep]) {
//       pendingMap[rep] = 0;
//     }

//     pendingMap[rep] += Number(v.remaining_amt) || 0;
//   });

//   // ================= FINAL TOTAL =================
//   const finalTotal: any = {
//     name: 'एकूण',

//     sub: 0,
//     'एकूण': 0,
//     'नवीन': 0,
//     'नूतनीकरण': 0,
//     'नूतनीकरणबाकी': 0,

//     net_नवीन: 0,
//     net_नूतनीकरण: 0,
//     net_एकूण: 0,
//     net_amount: 0,

//     yojana_नवीन: 0,
//     yojana_नूतनीकरण: 0,
//     yojana_एकूण: 0,
//     yojana_amount: 0,

//     ठेवीदार: 0,
//     देणगी: 0,
//     देणगी_amount: 0,
//     pending_amount: 0
//   };

//   this.subTypesName.forEach((b: any) => {
//     if (!b.isVisible) return;
//     const key = this.getKey(b.name);

//     finalTotal[key + '_नवीन'] = 0;
//     finalTotal[key + '_नूतनीकरण'] = 0;
//     finalTotal[key + '_नूतनीकरणबाकी'] = 0;
//     finalTotal[key + '_एकूण'] = 0;
//   });

//   this.finalData = [];

//   const uniqueOfficeReps = this.uniqueData(
//     this.offrepwiseData,
//     (a: any) => a.office_rep_name
//   ) as any[];

//   for (const officeRep of uniqueOfficeReps) {

//     const officeRepData = this.offrepwiseData.filter(
//       (a: any) => a.office_rep_name === officeRep.office_rep_name
//     );

//     const repDataGroup: any[] = [];

//     const uniqueReps = this.uniqueData(
//       officeRepData,
//       (a: any) => a.rep_name
//     ) as any[];

//     for (const rep of uniqueReps) {

//       const repRecords = officeRepData.filter(
//         (a: any) => a.rep_name === rep.rep_name
//       );

//       const repKey = normalize(rep.rep_name);
//       const donation = donationMap[repKey] || { count: 0, amount: 0 };
//       const pendingAmt = pendingMap[repKey] || 0;

//       let donationAssigned = false;
//       let pendingAssigned = false;

//       const uniqueDistricts = this.uniqueData(
//         repRecords,
//         (a: any) => a.rep_district
//       ) as any[];

//       for (const dist of uniqueDistricts) {

//         const districtwiseData = repRecords.filter(
//           (a: any) => a.rep_district === dist.rep_district
//         );

//         if (!districtwiseData.length) continue;

//         const subTotal: any = {
//           ...districtwiseData[0],

//           sub: 0,
//           'एकूण': 0,
//           'नवीन': 0,
//           'नूतनीकरण': 0,
//           'नूतनीकरणबाकी': 0,

//           net_नवीन: 0,
//           net_नूतनीकरण: 0,
//           net_एकूण: 0,
//           net_amount: 0,

//           yojana_नवीन: 0,
//           yojana_नूतनीकरण: 0,
//           yojana_एकूण: 0,
//           yojana_amount: 0,

//           ठेवीदार: 0,
//           देणगी: 0,
//           देणगी_amount: 0,
//           pending_amount: 0
//         };

//         this.subTypesName.forEach((b: any) => {
//           if (!b.isVisible) return;
//           const key = this.getKey(b.name);

//           subTotal[key + '_नवीन'] = 0;
//           subTotal[key + '_नूतनीकरण'] = 0;
//           subTotal[key + '_नूतनीकरणबाकी'] = 0;
//           subTotal[key + '_एकूण'] = 0;
//         });

//         const today = new Date();
//         today.setMonth(today.getMonth() + 1);

//         for (const record of districtwiseData) {

//           const subType = record.subscription_type || '';
//           const key = this.getKey(subType);
//           const isFuture = new Date(record.sub_perid_to_date) > today;
//           const amt = parseFloat(record.total_amt || 0);

//           if (subType !== DEPOSIT_TYPE) {
//             subTotal.sub++; finalTotal.sub++;
//           }

//           if (subType === DEPOSIT_TYPE && key) {
//             subTotal['ठेवीदार']++; finalTotal['ठेवीदार']++;

//             if (record.rcpt_type === 'New') {
//               subTotal[key + '_नवीन']++; finalTotal[key + '_नवीन']++;
//             } else {
//               subTotal[key + '_नूतनीकरण']++; finalTotal[key + '_नूतनीकरण']++;
//             }

//             subTotal[key + '_एकूण'] += amt;
//             finalTotal[key + '_एकूण'] += amt;
//           }

//           if (NET_TYPES.includes(subType)) {
//             if (isFuture) {
//               if (record.rcpt_type === 'New') {
//                 subTotal.net_नवीन++; finalTotal.net_नवीन++;
//               } else {
//                 subTotal.net_नूतनीकरण++; finalTotal.net_नूतनीकरण++;
//               }
//               subTotal.net_amount += amt;
//               finalTotal.net_amount += amt;
//             }
//             subTotal.net_एकूण++; finalTotal.net_एकूण++;
//           }

//           if (!EXCLUDE_YOJANA.includes(subType)) {
//             if (isFuture) {
//               if (record.rcpt_type === 'New') {
//                 subTotal.yojana_नवीन++; finalTotal.yojana_नवीन++;
//               } else {
//                 subTotal.yojana_नूतनीकरण++; finalTotal.yojana_नूतनीकरण++;
//               }
//               subTotal.yojana_amount += amt;
//               finalTotal.yojana_amount += amt;
//             }
//             subTotal.yojana_एकूण++; finalTotal.yojana_एकूण++;
//           }

//           if (key && subType !== DEPOSIT_TYPE) {
//             if (isFuture) {
//               if (record.rcpt_type === 'New') {
//                 subTotal[key + '_नवीन']++;
//                 finalTotal[key + '_नवीन']++;
//               } else {
//                 subTotal[key + '_नूतनीकरण']++;
//                 finalTotal[key + '_नूतनीकरण']++;
//               }

//               subTotal[key + '_एकूण'] += amt;
//               finalTotal[key + '_एकूण'] += amt;

//             } else {
//               subTotal[key + '_नूतनीकरणबाकी']++;
//               finalTotal[key + '_नूतनीकरणबाकी']++;
//             }
//           }

//           if (subType !== DEPOSIT_TYPE) {
//             if (isFuture) {
//               if (record.rcpt_type === 'New') {
//                 subTotal['नवीन']++; finalTotal['नवीन']++;
//               } else {
//                 subTotal['नूतनीकरण']++; finalTotal['नूतनीकरण']++;
//               }
//               subTotal['एकूण'] += amt;
//               finalTotal['एकूण'] += amt;
//             } else {
//               subTotal['नूतनीकरणबाकी']++;
//               finalTotal['नूतनीकरणबाकी']++;
//             }
//           }
//         }

//         // ✅ Donation
//         if (!donationAssigned) {
//           subTotal['देणगी'] = donation.count;
//           subTotal['देणगी_amount'] = donation.amount;
//           finalTotal['देणगी'] += donation.count;
//           finalTotal['देणगी_amount'] += donation.amount;
//           donationAssigned = true;
//         }

//         // ✅ Pending
//         if (!pendingAssigned) {
//           subTotal['pending_amount'] = pendingAmt;
//           finalTotal['pending_amount'] += pendingAmt;
//           pendingAssigned = true;
//         }

//         // ✅ ✅ NEW: HORIZONTAL ROW TOTAL (LAST COLUMN)
//         subTotal['row_total'] =
//           (subTotal['एकूण'] || 0) +
//           (subTotal['net_amount'] || 0) +
//           (subTotal['yojana_amount'] || 0) +
//           (subTotal['देणगी_amount'] || 0);

//         repDataGroup.push(subTotal);
//       }
//     }

//     const officeTotal = repDataGroup.reduce((acc: any, row: any) => {
//       Object.keys(row).forEach(k => {
//         if (typeof row[k] === 'number') {
//           acc[k] = (acc[k] || 0) + row[k];
//         }
//       });
//       return acc;
//     }, { name: officeRep.office_rep_name + ' - एकूण', isOfficeRepTotal: true });

//     repDataGroup.push(officeTotal);
//     this.finalData.push(repDataGroup);
//   }

//   // ✅ final total row total
//   finalTotal['row_total'] =
//     (finalTotal['एकूण'] || 0) +
//     (finalTotal['net_amount'] || 0) +
//     (finalTotal['yojana_amount'] || 0) +
//     (finalTotal['देणगी_amount'] || 0);

//   this.finalData.push(finalTotal);

//   this.isLoading = false;
// }

getRowTotal(row: any): number {
  let total = 0;

  // Net amount
  // total += Number(row.net_amount || 0);

  // Yojana amount
  // total += Number(row.yojana_amount || 0);

  // Main total amount
  total += Number(row['एकूण'] || 0);

  // ✅ ADD THIS (Deposit amount)
  const depositKey = this.getKey('मुदत ठेव (पंचवार्षिक वर्गणीदार)');
  total += Number(row[depositKey + '_एकूण'] || 0);

  // Sub types amount
  // this.subTypesName.forEach((sub: any) => {
  //   if (sub.isVisible) {
  //     const key = this.getKey(sub.name);
  //     total += Number(row[key + '_एकूण'] || 0);
  //   }
  // });

  // Donation
  total += Number(row['देणगी_amount'] || 0);

  // Pending
  total += Number(row['pending_amount'] || 0);

  return total;
}

// setData() {

//   if (!this.offrepwiseData) return;

//   const NET_TYPES = [
//     'वार्षिक',
//     'त्रैवार्षिक',
//     'पंचवार्षिक',
//     'ऑनलाईन अंक सहामाही',
//     'ऑनलाईन अंक वार्षिक'
//   ];

//   const EXCLUDE_YOJANA = [
//     ...NET_TYPES,
//     'मुदत ठेव (पंचवार्षिक वर्गणीदार)'
//   ];

//   const DEPOSIT_TYPE = 'मुदत ठेव (पंचवार्षिक वर्गणीदार)';

//   const normalize = (val: any) =>
//     (val || '')
//       .toString()
//       .trim()
//       .replace(/\s+/g, ' ')
//       .replace(/[^\w\u0900-\u097F ]/g, '')
//       .toLowerCase();

//   const normalizeText = (val: any) =>
//     (val || '').toString().trim().toLowerCase();

//   /* ================= FIX PRANT + DISTRICT ================= */

//   const districtPrantMap = new Map<string, string>();

//   this.offrepwiseData.forEach((row: any) => {

//     let dist = normalizeText(row.rep_district);
//     let prant = (row.prant_name || row.office_rep_name || 'Unknown').trim();

//     if (dist === 'मुंबई' || dist === 'mumbai') {
//       prant = 'कोकण प्रांत';
//     }

//     if (!districtPrantMap.has(dist)) {
//       districtPrantMap.set(dist, prant);
//     }

//     row.prant_name = districtPrantMap.get(dist);
//   });

//   /* ================= DONATION ================= */

//   const allVouchers = (Array.isArray(this.expenseLedgerData) ? this.expenseLedgerData : [])
//     .reduce((acc: any[], exp: any) => {

//       const expName = normalize(exp.exp_name);
//       const subExpName = normalize(exp.sub_exp_name);

//       const isDonation =
//         expName.includes('देणगी') ||
//         subExpName.includes('वर्गणी विभाग - देणगी');

//       if (isDonation && Array.isArray(exp.vouchers)) {
//         acc.push(...exp.vouchers);
//       }

//       return acc;
//     }, []);

//   const donationMap: any = {};
//   const start = new Date(this.startDate);
//   const end = new Date(this.endDate);

//   allVouchers.forEach((v: any) => {

//     const rep = normalize(v.rep_name);
//     if (!rep) return;

//     const vDate = new Date(v.voucher_date);

//     if (isNaN(vDate.getTime())) return;
//     if (vDate < start || vDate > end) return;

//     if (!donationMap[rep]) {
//       donationMap[rep] = { count: 0, amount: 0 };
//     }

//     donationMap[rep].count += 1;
//     donationMap[rep].amount += Number(v.exp_amt) || 0;
//   });

//   /* ================= PENDING ================= */

//   const pendingMap: any = {};

//   (this.getallVouchersData || []).forEach((v: any) => {

//     const rep = normalize(v.rep_name);

//     if (!rep) return;

//     if (!pendingMap[rep]) {
//       pendingMap[rep] = 0;
//     }

//     pendingMap[rep] += Number(v.remaining_amt) || 0;
//   });

//   /* ================= FINAL TOTAL ================= */

//   const finalTotal: any = {

//     name: 'एकूण',

//     sub: 0,

//     'एकूण': 0,
//     'एकूण_संख्या': 0,

//     'नवीन': 0,
//     'नूतनीकरण': 0,
//     'नूतनीकरणबाकी': 0,

//     net_नवीन: 0,
//     net_नूतनीकरण: 0,
//     net_नूतनीकरणबाकी: 0,
//     net_एकूण: 0,
//     net_amount: 0,

//     yojana_नवीन: 0,
//     yojana_नूतनीकरण: 0,
//     yojana_नूतनीकरणबाकी: 0,
//     yojana_एकूण: 0,
//     yojana_amount: 0,

//     ठेवीदार: 0,

//     देणगी: 0,
//     देणगी_amount: 0,

//     pending_amount: 0
//   };

//   /* ================= SUBTYPE TOTALS ================= */

//   this.subTypesName.forEach((b: any) => {

//     if (!b.isVisible) return;

//     const key = this.getKey(b.name);

//     finalTotal[key + '_नवीन'] = 0;
//     finalTotal[key + '_नूतनीकरण'] = 0;
//     finalTotal[key + '_नूतनीकरणबाकी'] = 0;
//     finalTotal[key + '_एकूण'] = 0;
//   });

//   this.finalData = [];

//   const prants = this.uniqueData(
//     this.offrepwiseData,
//     (a: any) => normalize(a.prant_name)
//   ) as any[];

//   /* ================= CUSTOM PRANT ORDER ================= */

//   const PRANT_ORDER = [
//     'कोकण प्रांत',
//     'पश्चिम प्रांत',
//     'देवगिरी प्रांत',
//     'विदर्भ प्रांत'
//   ];

//   prants.sort((a: any, b: any) => {

//     const nameA = (a.prant_name || '').trim();
//     const nameB = (b.prant_name || '').trim();

//     const indexA = PRANT_ORDER.indexOf(nameA);
//     const indexB = PRANT_ORDER.indexOf(nameB);

//     if (indexA !== -1 && indexB !== -1) {
//       return indexA - indexB;
//     }

//     if (indexA !== -1) return -1;
//     if (indexB !== -1) return 1;

//     return nameA.localeCompare(nameB);
//   });

//   for (const prant of prants) {

//     const prantRows = this.offrepwiseData.filter(
//       (a: any) =>
//         normalize(a.prant_name) === normalize(prant.prant_name)
//     );

//     const officeGroup: any[] = [];

//     const districts = this.uniqueData(
//       prantRows,
//       (a: any) => normalize(a.rep_district)
//     ) as any[];

//     for (const dist of districts) {

//       const districtRows = prantRows.filter(
//         (a: any) =>
//           normalize(a.rep_district) === normalize(dist.rep_district)
//       );

//       const talukas = this.uniqueData(
//         districtRows,
//         (a: any) => a.rep_taluka
//       ) as any[];

//       for (const tal of talukas) {

//         const talukaRecords = districtRows.filter(
//           (a: any) => a.rep_taluka === tal.rep_taluka
//         );

//         if (!talukaRecords.length) continue;

//         const repKey = normalize(talukaRecords[0]?.rep_name);

//         const donation =
//           donationMap[repKey] || { count: 0, amount: 0 };

//         const pendingAmt =
//           pendingMap[repKey] || 0;

//         const subTotal: any = {

//           ...talukaRecords[0],

//           sub: 0,

//           'एकूण': 0,
//           'एकूण_संख्या': 0,

//           'नवीन': 0,
//           'नूतनीकरण': 0,
//           'नूतनीकरणबाकी': 0,

//           net_नवीन: 0,
//           net_नूतनीकरण: 0,
//           net_नूतनीकरणबाकी: 0,
//           net_एकूण: 0,
//           net_amount: 0,

//           yojana_नवीन: 0,
//           yojana_नूतनीकरण: 0,
//           yojana_नूतनीकरणबाकी: 0,
//           yojana_एकूण: 0,
//           yojana_amount: 0,

//           ठेवीदार: 0,

//           देणगी: 0,
//           देणगी_amount: 0,

//           pending_amount: 0
//         };

//         /* ================= SUBTYPE INIT ================= */

//         this.subTypesName.forEach((b: any) => {

//           if (!b.isVisible) return;

//           const key = this.getKey(b.name);

//           subTotal[key + '_नवीन'] = 0;
//           subTotal[key + '_नूतनीकरण'] = 0;
//           subTotal[key + '_नूतनीकरणबाकी'] = 0;
//           subTotal[key + '_एकूण'] = 0;
//         });

//         const today = new Date();
//         today.setMonth(today.getMonth() + 1);

//         for (const record of talukaRecords) {

//           const subType = record.subscription_type || '';
//           const key = this.getKey(subType);

//           // ✅ IMPORTANT FIX
//           // amount should always be added
//           // expiry logic only for counts
//           const amt = Number(record.total_amt || 0);

//           const isFuture =
//             new Date(record.sub_perid_to_date) > today;

//           // ================= DEPOSIT TYPE HANDLING =================
//           if (subType === DEPOSIT_TYPE && key) {

//             subTotal['ठेवीदार']++;
//             finalTotal['ठेवीदार']++;

//             if (record.rcpt_type === 'New') {
//               subTotal[key + '_नवीन']++;
//               finalTotal[key + '_नवीन']++;
//             } else {
//               subTotal[key + '_नूतनीकरण']++;
//               finalTotal[key + '_नूतनीकरण']++;
//             }

//             // ✅ ALWAYS ADD DEPOSIT AMOUNT
//             subTotal[key + '_एकूण'] += amt;
//             finalTotal[key + '_एकूण'] += amt;
//           }

//           if (subType !== DEPOSIT_TYPE) {

//             subTotal.sub++;
//             finalTotal.sub++;

//             // ✅ MAIN TOTAL AMOUNT ALWAYS ADD
//             subTotal['एकूण'] += amt;
//             finalTotal['एकूण'] += amt;
//           }

//           /* ================= SUBTYPE ================= */

//           if (key && subType !== DEPOSIT_TYPE) {

//             // ✅ ALWAYS ADD AMOUNT
//             subTotal[key + '_एकूण'] += amt;
//             finalTotal[key + '_एकूण'] += amt;

//             if (isFuture) {

//               if (record.rcpt_type === 'New') {

//                 subTotal[key + '_नवीन']++;
//                 finalTotal[key + '_नवीन']++;

//               } else {

//                 subTotal[key + '_नूतनीकरण']++;
//                 finalTotal[key + '_नूतनीकरण']++;
//               }

//             } else {

//               subTotal[key + '_नूतनीकरणबाकी']++;
//               finalTotal[key + '_नूतनीकरणबाकी']++;
//             }
//           }

//           /* ================= NET ================= */

//           if (NET_TYPES.includes(subType)) {

//             // ✅ ALWAYS ADD NET AMOUNT
//             subTotal.net_amount += amt;
//             finalTotal.net_amount += amt;

//             if (isFuture) {

//               if (record.rcpt_type === 'New') {

//                 subTotal.net_नवीन++;
//                 finalTotal.net_नवीन++;

//               } else {

//                 subTotal.net_नूतनीकरण++;
//                 finalTotal.net_नूतनीकरण++;
//               }

//             } else {

//               subTotal.net_नूतनीकरणबाकी++;
//               finalTotal.net_नूतनीकरणबाकी++;
//             }

//             subTotal.net_एकूण++;
//             finalTotal.net_एकूण++;
//           }

//           /* ================= YOJANA ================= */

//           if (!EXCLUDE_YOJANA.includes(subType)) {

//             // ✅ ALWAYS ADD YOJANA AMOUNT
//             subTotal.yojana_amount += amt;
//             finalTotal.yojana_amount += amt;

//             if (isFuture) {

//               if (record.rcpt_type === 'New') {

//                 subTotal.yojana_नवीन++;
//                 finalTotal.yojana_नवीन++;

//               } else {

//                 subTotal.yojana_नूतनीकरण++;
//                 finalTotal.yojana_नूतनीकरण++;
//               }

//             } else {

//               subTotal.yojana_नूतनीकरणबाकी++;
//               finalTotal.yojana_नूतनीकरणबाकी++;
//             }

//             subTotal.yojana_एकूण++;
//             finalTotal.yojana_एकूण++;
//           }

//           /* ================= MAIN COUNT ================= */

//           if (subType !== DEPOSIT_TYPE) {

//             if (isFuture) {

//               if (record.rcpt_type === 'New') {

//                 subTotal['नवीन']++;
//                 finalTotal['नवीन']++;

//               } else {

//                 subTotal['नूतनीकरण']++;
//                 finalTotal['नूतनीकरण']++;
//               }

//             } else {

//               subTotal['नूतनीकरणबाकी']++;
//               finalTotal['नूतनीकरणबाकी']++;
//             }
//           }
//         }

//         /* ================= FINAL COUNTS ================= */

//         subTotal['एकूण_संख्या'] =
//           Number(subTotal['नवीन'] || 0) +
//           Number(subTotal['नूतनीकरण'] || 0);

//         finalTotal['एकूण_संख्या'] +=
//           subTotal['एकूण_संख्या'];

//         /* ================= DONATION ================= */

//         subTotal['देणगी'] = donation.count;
//         subTotal['देणगी_amount'] = donation.amount;

//         finalTotal['देणगी'] += donation.count;
//         finalTotal['देणगी_amount'] += donation.amount;

//         /* ================= PENDING ================= */

//         subTotal['pending_amount'] = pendingAmt;
//         finalTotal['pending_amount'] += pendingAmt;

//         /* ================= ROW TOTAL ================= */
//         subTotal['row_total'] =
//           (subTotal['एकूण'] || 0) +
//           (subTotal['net_amount'] || 0) +
//           (subTotal['yojana_amount'] || 0) +
//           (subTotal['देणगी_amount'] || 0);

//         officeGroup.push(subTotal);
//       }
//     }

//     this.finalData.push(officeGroup);
//   }

//   /* ================= FINAL TOTAL ROW_TOTAL ================= */
//   finalTotal['row_total'] =
//     (finalTotal['एकूण'] || 0) +
//     (finalTotal['net_amount'] || 0) +
//     (finalTotal['yojana_amount'] || 0) +
//     (finalTotal['देणगी_amount'] || 0);

//   this.finalData.push(finalTotal);

//   this.isLoading = false;
// }

// Existing Correct Code
//    setData() {
//   if (!this.offrepwiseData) return;

//   const NET_TYPES = [
//     'वार्षिक',
//     'त्रैवार्षिक',
//     'पंचवार्षिक',
//     'ऑनलाईन अंक सहामाही',
//     'ऑनलाईन अंक वार्षिक'
//   ];

//   const EXCLUDE_YOJANA = [
//     ...NET_TYPES,
//     'मुदत ठेव (पंचवार्षिक वर्गणीदार)'
//   ];

//   const DEPOSIT_TYPE = 'मुदत ठेव (पंचवार्षिक वर्गणीदार)';

//   const normalize = (val: any) =>
//     (val || '')
//       .toString()
//       .trim()
//       .replace(/\s+/g, ' ')
//       .replace(/[^\w\u0900-\u097F ]/g, '')
//       .toLowerCase();

//   const normalizeText = (val: any) =>
//     (val || '').toString().trim().toLowerCase();

//   /* ================= FIX PRANT + DISTRICT ================= */
//   const districtPrantMap = new Map<string, string>();
//   this.offrepwiseData.forEach((row: any) => {
//     let dist = normalizeText(row.rep_district);
//     let prant = (row.prant_name || row.office_rep_name || 'Unknown').trim();
//     if (dist === 'मुंबई' || dist === 'mumbai') {
//       prant = 'कोकण प्रांत';
//     }
//     if (!districtPrantMap.has(dist)) {
//       districtPrantMap.set(dist, prant);
//     }
//     row.prant_name = districtPrantMap.get(dist);
//   });

//   /* ================= DONATION ================= */
//   const allVouchers = (Array.isArray(this.expenseLedgerData) ? this.expenseLedgerData : [])
//     .reduce((acc: any[], exp: any) => {
//       const expName = normalize(exp.exp_name);
//       const subExpName = normalize(exp.sub_exp_name);
//       const isDonation =
//         expName.includes('देणगी') ||
//         subExpName.includes('वर्गणी विभाग - देणगी');
//       if (isDonation && Array.isArray(exp.vouchers)) {
//         acc.push(...exp.vouchers);
//       }
//       return acc;
//     }, []);

//   const donationMap: any = {};
//   const start = new Date(this.startDate);
//   const end = new Date(this.endDate);

//   allVouchers.forEach((v: any) => {
//     const rep = normalize(v.rep_name);
//     if (!rep) return;
//     const vDate = new Date(v.voucher_date);
//     if (isNaN(vDate.getTime())) return;
//     if (vDate < start || vDate > end) return;
//     if (!donationMap[rep]) {
//       donationMap[rep] = { count: 0, amount: 0 };
//     }
//     donationMap[rep].count += 1;
//     donationMap[rep].amount += Number(v.exp_amt) || 0;
//   });

//   /* ================= PENDING ================= */
//   const pendingMap: any = {};
//   (this.getallVouchersData || []).forEach((v: any) => {
//     const rep = normalize(v.rep_name);
//     if (!rep) return;
//     if (!pendingMap[rep]) {
//       pendingMap[rep] = 0;
//     }
//     pendingMap[rep] += Number(v.remaining_amt) || 0;
//   });

//   /* ================= FINAL TOTAL OBJECT ================= */
//   const finalTotal: any = {
//     name: 'एकूण',
//     sub: 0,
//     'एकूण': 0,
//     'नवीन': 0,
//     'नूतनीकरण': 0,
//     'नूतनीकरणबाकी': 0,
//     net_नवीन: 0,
//     net_नूतनीकरण: 0,
//     net_नूतनीकरणबाकी: 0,
//     net_एकूण: 0,
//     net_amount: 0,
//     yojana_नवीन: 0,
//     yojana_नूतनीकरण: 0,
//     yojana_नूतनीकरणबाकी: 0,
//     yojana_एकूण: 0,
//     yojana_amount: 0,
//     ठेवीदार: 0,
//     देणगी: 0,
//     देणगी_amount: 0,
//     pending_amount: 0
//   };

//   this.subTypesName.forEach((b: any) => {
//     if (!b.isVisible) return;
//     const key = this.getKey(b.name);
//     finalTotal[key + '_नवीन'] = 0;
//     finalTotal[key + '_नूतनीकरण'] = 0;
//     finalTotal[key + '_नूतनीकरणबाकी'] = 0;
//     finalTotal[key + '_एकूण'] = 0;
//   });

//   this.finalData = [];

//   /* ================= GROUP BY PRANT with CUSTOM ORDER ================= */
//   const prants = this.uniqueData(
//     this.offrepwiseData,
//     (a: any) => normalize(a.prant_name)
//   ) as any[];

//   // ----- SORT PRANTS IN DESIRED SEQUENCE -----
//   const desiredPrantOrder = ['कोकण प्रांत', 'पश्चिम प्रांत', 'देवगिरी प्रांत', 'विदर्भ प्रांत'];
//   prants.sort((a, b) => {
//     const indexA = desiredPrantOrder.indexOf(a.prant_name);
//     const indexB = desiredPrantOrder.indexOf(b.prant_name);
//     if (indexA !== -1 && indexB !== -1) return indexA - indexB;
//     if (indexA !== -1) return -1;
//     if (indexB !== -1) return 1;
//     return (a.prant_name || '').localeCompare(b.prant_name || '');
//   });

//   for (const prant of prants) {
//     const prantRows = this.offrepwiseData.filter(
//       (a: any) => normalize(a.prant_name) === normalize(prant.prant_name)
//     );

//     const officeGroup: any[] = [];

//     const districts = this.uniqueData(
//       prantRows,
//       (a: any) => normalize(a.rep_district)
//     ) as any[];

//     for (const dist of districts) {
//       const districtRows = prantRows.filter(
//         (a: any) => normalize(a.rep_district) === normalize(dist.rep_district)
//       );

//       const talukas = this.uniqueData(
//         districtRows,
//         (a: any) => a.rep_taluka
//       ) as any[];

//       for (const tal of talukas) {
//         const talukaRecords = districtRows.filter(
//           (a: any) => a.rep_taluka === tal.rep_taluka
//         );

//         if (!talukaRecords.length) continue;

//         // collect all unique reps inside this taluka
//         const repSet = new Set<string>();
//         talukaRecords.forEach((r: any) => {
//           const key = normalize(r.rep_name);
//           if (key) repSet.add(key);
//         });

//         let donation = { count: 0, amount: 0 };
//         let pendingAmt = 0;
//         repSet.forEach((repKey: string) => {
//           const d = donationMap[repKey] || { count: 0, amount: 0 };
//           donation.count += d.count;
//           donation.amount += d.amount;
//           pendingAmt += pendingMap[repKey] || 0;
//         });

//         const subTotal: any = {
//           ...talukaRecords[0],
//           sub: 0,
//           'एकूण': 0,
//           'नवीन': 0,
//           'नूतनीकरण': 0,
//           'नूतनीकरणबाकी': 0,
//           net_नवीन: 0,
//           net_नूतनीकरण: 0,
//           net_नूतनीकरणबाकी: 0,
//           net_एकूण: 0,
//           net_amount: 0,
//           yojana_नवीन: 0,
//           yojana_नूतनीकरण: 0,
//           yojana_नूतनीकरणबाकी: 0,
//           yojana_एकूण: 0,
//           yojana_amount: 0,
//           ठेवीदार: 0,
//           देणगी: donation.count,
//           देणगी_amount: donation.amount,
//           pending_amount: pendingAmt
//         };

//         this.subTypesName.forEach((b: any) => {
//           if (!b.isVisible) return;
//           const key = this.getKey(b.name);
//           subTotal[key + '_नवीन'] = 0;
//           subTotal[key + '_नूतनीकरण'] = 0;
//           subTotal[key + '_नूतनीकरणबाकी'] = 0;
//           subTotal[key + '_एकूण'] = 0;
//         });

//         const today = new Date();
//         today.setMonth(today.getMonth() + 1);

//         for (const record of talukaRecords) {
//           const subType = record.subscription_type || '';
//           const key = this.getKey(subType);
//           const amt = Number(record.total_amt) || 0;
//           const isFuture = new Date(record.sub_perid_to_date) > today;

//           if (subType !== DEPOSIT_TYPE) {
//             subTotal.sub++;
//             finalTotal.sub++;
//           }

//           // DEPOSIT type
//           if (subType === DEPOSIT_TYPE && key) {
//             subTotal['ठेवीदार']++;
//             finalTotal['ठेवीदार']++;

//             if (record.rcpt_type === 'New') {
//               subTotal[key + '_नवीन']++;
//               finalTotal[key + '_नवीन']++;
//             } else {
//               subTotal[key + '_नूतनीकरण']++;
//               finalTotal[key + '_नूतनीकरण']++;
//             }

//             subTotal[key + '_एकूण'] = (subTotal[key + '_एकूण'] || 0) + amt;
//             finalTotal[key + '_एकूण'] = (finalTotal[key + '_एकूण'] || 0) + amt;
//           }

//           // NET plans
//           if (NET_TYPES.includes(subType)) {
//             if (isFuture) {
//               if (record.rcpt_type === 'New') {
//                 subTotal.net_नवीन++;
//                 finalTotal.net_नवीन++;
//               } else {
//                 subTotal.net_नूतनीकरण++;
//                 finalTotal.net_नूतनीकरण++;
//               }
//             } else {
//               subTotal.net_नूतनीकरणबाकी++;
//               finalTotal.net_नूतनीकरणबाकी++;
//             }

//             subTotal.net_amount = (subTotal.net_amount || 0) + amt;
//             finalTotal.net_amount = (finalTotal.net_amount || 0) + amt;
//             subTotal.net_एकूण++;
//             finalTotal.net_एकूण++;
//           }

//           // Yojana (exclude NET and DEPOSIT)
//           if (!EXCLUDE_YOJANA.includes(subType)) {
//             if (isFuture) {
//               if (record.rcpt_type === 'New') {
//                 subTotal.yojana_नवीन++;
//                 finalTotal.yojana_नवीन++;
//               } else {
//                 subTotal.yojana_नूतनीकरण++;
//                 finalTotal.yojana_नूतनीकरण++;
//               }
//             } else {
//               subTotal.yojana_नूतनीकरणबाकी++;
//               finalTotal.yojana_नूतनीकरणबाकी++;
//             }

//             subTotal.yojana_amount = (subTotal.yojana_amount || 0) + amt;
//             finalTotal.yojana_amount = (finalTotal.yojana_amount || 0) + amt;
//             subTotal.yojana_एकूण++;
//             finalTotal.yojana_एकूण++;
//           }

//           // Subscription type (if not DEPOSIT)
//           if (key && subType !== DEPOSIT_TYPE) {
//             if (isFuture) {
//               if (record.rcpt_type === 'New') {
//                 subTotal[key + '_नवीन']++;
//                 finalTotal[key + '_नवीन']++;
//               } else {
//                 subTotal[key + '_नूतनीकरण']++;
//                 finalTotal[key + '_नूतनीकरण']++;
//               }
//             } else {
//               subTotal[key + '_नूतनीकरणबाकी']++;
//               finalTotal[key + '_नूतनीकरणबाकी']++;
//             }

//             subTotal[key + '_एकूण'] = (subTotal[key + '_एकूण'] || 0) + amt;
//             finalTotal[key + '_एकूण'] = (finalTotal[key + '_एकूण'] || 0) + amt;
//           }

//           // Main totals (non‑deposit)
//           if (subType !== DEPOSIT_TYPE) {
//             if (isFuture) {
//               if (record.rcpt_type === 'New') {
//                 subTotal['नवीन']++;
//                 finalTotal['नवीन']++;
//               } else {
//                 subTotal['नूतनीकरण']++;
//                 finalTotal['नूतनीकरण']++;
//               }
//             } else {
//               subTotal['नूतनीकरणबाकी']++;
//               finalTotal['नूतनीकरणबाकी']++;
//             }

//             subTotal['एकूण'] = (subTotal['एकूण'] || 0) + amt;
//             finalTotal['एकूण'] = (finalTotal['एकूण'] || 0) + amt;
//           }
//         }

//         subTotal['एकूण_संख्या'] = subTotal['नवीन'] + subTotal['नूतनीकरण'];
//         finalTotal['एकूण_संख्या'] += subTotal['एकूण_संख्या'];

//         finalTotal['देणगी'] += subTotal['देणगी'];
//         finalTotal['देणगी_amount'] += subTotal['देणगी_amount'];
//         finalTotal['pending_amount'] += subTotal['pending_amount'];

//         officeGroup.push(subTotal);
//       }
//     }

//     this.finalData.push(officeGroup);
//   }

//   // final total row
//   finalTotal['row_total'] =
//     (finalTotal['एकूण'] || 0) +
//     (finalTotal['net_amount'] || 0) +
//     (finalTotal['yojana_amount'] || 0) +
//     (finalTotal['देणगी_amount'] || 0);

//   this.finalData.push(finalTotal);
//   this.isLoading = false;
// }

getDistrictGroups(rows: any[]) {
  if (!Array.isArray(rows)) return [];

  const map = new Map();

  rows.forEach(row => {
    if (row.isOfficeRepTotal) return;

    const key = row.rep_district || 'Unknown';

    if (!map.has(key)) {
      map.set(key, {
        rep_district: key,
        rows: [],
        total: {}
      });
    }

    map.get(key).rows.push(row);
  });

  return Array.from(map.values()).map(group => {
    const total = {};

    group.rows.forEach((row: any) => {
      Object.keys(row).forEach(k => {
        if (typeof row[k] === 'number') {
          total[k] = (total[k] || 0) + row[k];
        }
      });
    });

    total['rep_district'] = group.rep_district;

    return {
      ...group,
      total
    };
  });
}
 
 createEmptyTotal(ref: any): any {
   const total: any = {
     name: 'एकूण',
     district_name: ref.district_name,
     office_rep_name: ref.office_rep_name,
     sub: 0, 'एकूण': 0, 'नवीन': 0, 'नूतनीकरण': 0, 'नूतनीकरणबाकी': 0
   };
 
   this.subTypesName.forEach(sub => {
     if (sub.isVisible) {
       const key = this.getKey(sub.name);
       total[key + '_नवीन'] = 0;
       total[key + '_नूतनीकरण'] = 0;
       total[key + '_एकूण'] = 0;
       total[key + '_नूतनीकरणबाकी'] = 0;
     }
   });
 
   return total;
 }
 
 addToTotal(total: any, record: any): void {
   total.sub += record.sub || 0;
   total['एकूण'] += record['एकूण'] || 0;
   total['नवीन'] += record['नवीन'] || 0;
   total['नूतनीकरण'] += record['नूतनीकरण'] || 0;
   total['नूतनीकरणबाकी'] += record['नूतनीकरणबाकी'] || 0;
 
   this.subTypesName.forEach(sub => {
     if (sub.isVisible) {
       const key = this.getKey(sub.name);
       total[key + '_नवीन'] += record[key + '_नवीन'] || 0;
       total[key + '_नूतनीकरण'] += record[key + '_नूतनीकरण'] || 0;
       total[key + '_एकूण'] += record[key + '_एकूण'] || 0;
       total[key + '_नूतनीकरणबाकी'] += record[key + '_नूतनीकरणबाकी'] || 0;
     }
   });
 }
 
   getKey(name) {
     return name.replaceAll(' ', '_');
   }
 
   uniqueData(data, key) {
     return [...new Map(data.map((a) => [key(a), a])).values()];
   }

   getPrantTotal(rows: any[]) {
  if (!Array.isArray(rows)) return {};

  const total: any = {};

  rows.forEach((row: any) => {
    Object.keys(row).forEach(key => {
      if (typeof row[key] === 'number') {
        total[key] = (total[key] || 0) + row[key];
      }
    });
  });

  return total;
}

setData() {

  if (!this.offrepwiseData) return;

  const NET_TYPES = [
    'वार्षिक',
    'त्रैवार्षिक',
    'पंचवार्षिक',
    'ऑनलाईन अंक सहामाही',
    'ऑनलाईन अंक वार्षिक'
  ];

  const EXCLUDE_YOJANA = [
    ...NET_TYPES,
    'मुदत ठेव (पंचवार्षिक वर्गणीदार)'
  ];

  const DEPOSIT_TYPE = 'मुदत ठेव (पंचवार्षिक वर्गणीदार)';

  const normalize = (val: any) =>
    (val || '')
      .toString()
      .trim()
      .replace(/\s+/g, ' ')
      .replace(/[^\w\u0900-\u097F ]/g, '')
      .toLowerCase();

  const normalizeText = (val: any) =>
    (val || '').toString().trim().toLowerCase();

  /* ================= FIX PRANT + DISTRICT ================= */

  const districtPrantMap = new Map<string, string>();

  this.offrepwiseData.forEach((row: any) => {

    let dist = normalizeText(row.rep_district);

    let prant =
      (row.prant_name || row.office_rep_name || 'Unknown').trim();

    if (dist === 'मुंबई' || dist === 'mumbai') {
      prant = 'कोकण प्रांत';
    }

    if (!districtPrantMap.has(dist)) {
      districtPrantMap.set(dist, prant);
    }

    row.prant_name = districtPrantMap.get(dist);
  });

  // =========================================================
  // 🔥 REP MASTER MAP
  // FOR PENDING RECORD DISTRICT/TALUKA/PRANT
  // =========================================================

  const repMasterMap: any = {};

  (this.offrepwiseData || []).forEach((r: any) => {

    const repKey = normalize(r.rep_name);

    if (!repKey) return;

    if (
      !repMasterMap[repKey] &&
      r.rep_district &&
      r.rep_district !== 'इतर' &&
      r.rep_district !== '-'
    ) {

      repMasterMap[repKey] = {

        rep_district: r.rep_district || 'इतर',

        rep_taluka: r.rep_taluka || '-',

        prant_name:
          r.prant_name ||
          districtPrantMap.get(
            normalizeText(r.rep_district)
          ) ||
          'इतर'
      };
    }
  });

  // =========================================================
  // 🔥 INSERT PENDING ONLY RECORDS
  // UNDER CORRECT PRANT → DISTRICT → TALUKA
  // =========================================================

  (this.getallVouchersData || []).forEach((v: any) => {

    const repName =
      v.rep_name ||
      v.representative_name ||
      v.name ||
      '';

    const repKey = normalize(repName);

    if (!repKey) return;

    // already exists
    const existingRecord = (this.offrepwiseData || []).find(
      (x: any) =>
        normalize(x.rep_name) === repKey
    );

    if (existingRecord) return;

    const master = repMasterMap[repKey] || {};

    const district =
      master.rep_district ||
      v.rep_district ||
      v.district ||
      'इतर';

    const taluka =
      master.rep_taluka ||
      v.rep_taluka ||
      v.taluka ||
      '-';

    const prant =
      master.prant_name ||
      districtPrantMap.get(
        normalizeText(district)
      ) ||
      v.prant_name ||
      'इतर';

    // push virtual pending row
    this.offrepwiseData.push({

      rep_name: repName,

      rep_district: district,

      rep_taluka: taluka,

      prant_name: prant,

      office_rep_name: '',

      subscription_type: '',

      rcpt_type: '',

      total_amt: 0,

      sub_perid_to_date: new Date(),

      isPendingOnlyRecord: true
    });
  });

  /* ================= DONATION ================= */

  // const allVouchers = (
  //   Array.isArray(this.expenseLedgerData)
  //     ? this.expenseLedgerData
  //     : []
  // ).reduce((acc: any[], exp: any) => {

  //   const expName = normalize(exp.exp_name);

  //   const subExpName = normalize(exp.sub_exp_name);

  //   const isDonation =
  //     expName.includes('देणगी') ||
  //     subExpName.includes('वर्गणी विभाग');

  //   if (
  //     isDonation &&
  //     Array.isArray(exp.vouchers)
  //   ) {
  //     acc.push(...exp.vouchers);
  //   }

  //   return acc;

  // }, []);

  const expenseData = Array.isArray(this.expenseLedgerData)
  ? this.expenseLedgerData
  : (this.expenseLedgerData ? [this.expenseLedgerData] : []);

const allVouchers = expenseData.reduce((acc: any[], exp: any) => {

  const expName = normalize(exp.exp_name);
  const subExpName = normalize(exp.sub_exp_name);

  const isDonation =
    expName.includes('देणगी') ||
    subExpName.includes('वर्गणी विभाग');

  if (isDonation && Array.isArray(exp.vouchers)) {
    acc.push(...exp.vouchers);
  }

  return acc;

}, []);

console.log('expenseLedgerData =', this.expenseLedgerData);
console.log('expenseData =', expenseData);
console.log('allVouchers =', allVouchers);
// console.log('donationMap =', donationMap);

  const donationMap: any = {};

  const start = new Date(this.startDate);

  const end = new Date(this.endDate);

  allVouchers.forEach((v: any) => {

    const rep = normalize(v.rep_name);

    if (!rep) return;

    const vDate = new Date(v.voucher_date);

    if (isNaN(vDate.getTime())) return;

    if (vDate < start || vDate > end) return;

    if (!donationMap[rep]) {

      donationMap[rep] = {
        count: 0,
        amount: 0
      };
    }

    donationMap[rep].count += 1;

    donationMap[rep].amount +=
      Number(v.exp_amt) || 0;
  });

  /* ================= PENDING ================= */

  const pendingMap: any = {};

  (this.getallVouchersData || []).forEach((v: any) => {

    const repName =
      v.rep_name ||
      v.representative_name ||
      v.name ||
      '';

    const rep = normalize(repName);

    if (!rep) return;

    if (!pendingMap[rep]) {
      pendingMap[rep] = 0;
    }

    pendingMap[rep] +=
      Number(v.remaining_amt) ||
      Number(v.pending_amount) ||
      0;
  });

  /* ================= FINAL TOTAL OBJECT ================= */

  const finalTotal: any = {

    name: 'एकूण',

    sub: 0,

    'एकूण': 0,

    'नवीन': 0,

    'नूतनीकरण': 0,

    'नूतनीकरणबाकी': 0,

    net_नवीन: 0,

    net_नूतनीकरण: 0,

    net_नूतनीकरणबाकी: 0,

    net_एकूण: 0,

    net_amount: 0,

    yojana_नवीन: 0,

    yojana_नूतनीकरण: 0,

    yojana_नूतनीकरणबाकी: 0,

    yojana_एकूण: 0,

    yojana_amount: 0,

    ठेवीदार: 0,

    देणगी: 0,

    देणगी_amount: 0,

    pending_amount: 0
  };

  this.subTypesName.forEach((b: any) => {

    if (!b.isVisible) return;

    const key = this.getKey(b.name);

    finalTotal[key + '_नवीन'] = 0;

    finalTotal[key + '_नूतनीकरण'] = 0;

    finalTotal[key + '_नूतनीकरणबाकी'] = 0;

    finalTotal[key + '_एकूण'] = 0;
  });

  this.finalData = [];

  /* ================= GROUP BY PRANT ================= */

  const prants = this.uniqueData(
    this.offrepwiseData,
    (a: any) => normalize(a.prant_name)
  ) as any[];

  const desiredPrantOrder = [
    'कोकण प्रांत',
    'पश्चिम प्रांत',
    'देवगिरी प्रांत',
    'विदर्भ प्रांत'
  ];

  prants.sort((a, b) => {

    const indexA =
      desiredPrantOrder.indexOf(a.prant_name);

    const indexB =
      desiredPrantOrder.indexOf(b.prant_name);

    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }

    if (indexA !== -1) return -1;

    if (indexB !== -1) return 1;

    return (a.prant_name || '').localeCompare(
      b.prant_name || ''
    );
  });

  for (const prant of prants) {

    const prantRows = this.offrepwiseData.filter(
      (a: any) =>
        normalize(a.prant_name) ===
        normalize(prant.prant_name)
    );

    const officeGroup: any[] = [];

    const districts = this.uniqueData(
      prantRows,
      (a: any) => normalize(a.rep_district)
    ) as any[];

    for (const dist of districts) {

      const districtRows = prantRows.filter(
        (a: any) =>
          normalize(a.rep_district) ===
          normalize(dist.rep_district)
      );

      const talukas = this.uniqueData(
        districtRows,
        (a: any) => a.rep_taluka
      ) as any[];

      for (const tal of talukas) {

        const talukaRecords = districtRows.filter(
          (a: any) =>
            a.rep_taluka === tal.rep_taluka
        );

        if (!talukaRecords.length) continue;

        const repSet = new Set<string>();

        talukaRecords.forEach((r: any) => {

          const key = normalize(r.rep_name);

          if (key) repSet.add(key);
        });

        let donation = {
          count: 0,
          amount: 0
        };

        let pendingAmt = 0;

        repSet.forEach((repKey: string) => {

          const d = donationMap[repKey] || {
            count: 0,
            amount: 0
          };

          donation.count += d.count;

          donation.amount += d.amount;

          pendingAmt +=
            pendingMap[repKey] || 0;
        });

        const subTotal: any = {

          ...talukaRecords[0],

          sub: 0,

          'एकूण': 0,

          'नवीन': 0,

          'नूतनीकरण': 0,

          'नूतनीकरणबाकी': 0,

          net_नवीन: 0,

          net_नूतनीकरण: 0,

          net_नूतनीकरणबाकी: 0,

          net_एकूण: 0,

          net_amount: 0,

          yojana_नवीन: 0,

          yojana_नूतनीकरण: 0,

          yojana_नूतनीकरणबाकी: 0,

          yojana_एकूण: 0,

          yojana_amount: 0,

          ठेवीदार: 0,

          देणगी: donation.count,

          देणगी_amount: donation.amount,

          pending_amount: pendingAmt
        };

        this.subTypesName.forEach((b: any) => {

          if (!b.isVisible) return;

          const key = this.getKey(b.name);

          subTotal[key + '_नवीन'] = 0;

          subTotal[key + '_नूतनीकरण'] = 0;

          subTotal[key + '_नूतनीकरणबाकी'] = 0;

          subTotal[key + '_एकूण'] = 0;
        });

        const today = new Date();

        today.setMonth(today.getMonth() + 1);

        for (const record of talukaRecords) {

          if (record.isPendingOnlyRecord) {
            continue;
          }

          const subType =
            record.subscription_type || '';

          const key = this.getKey(subType);

          const amt =
            Number(record.total_amt) || 0;

          const isFuture =
            new Date(
              record.sub_perid_to_date
            ) > today;

          if (subType !== DEPOSIT_TYPE) {

            subTotal.sub++;

            finalTotal.sub++;
          }

          if (
            subType === DEPOSIT_TYPE &&
            key
          ) {

            subTotal['ठेवीदार']++;

            finalTotal['ठेवीदार']++;

            if (record.rcpt_type === 'New') {

              subTotal[key + '_नवीन']++;

              finalTotal[key + '_नवीन']++;

            } else {

              subTotal[key + '_नूतनीकरण']++;

              finalTotal[key + '_नूतनीकरण']++;
            }

            subTotal[key + '_एकूण'] =
              (subTotal[key + '_एकूण'] || 0) + amt;

            finalTotal[key + '_एकूण'] =
              (finalTotal[key + '_एकूण'] || 0) + amt;
          }

          if (NET_TYPES.includes(subType)) {

            if (isFuture) {

              if (record.rcpt_type === 'New') {

                subTotal.net_नवीन++;

                finalTotal.net_नवीन++;

              } else {

                subTotal.net_नूतनीकरण++;

                finalTotal.net_नूतनीकरण++;
              }

            } else {

              subTotal.net_नूतनीकरणबाकी++;

              finalTotal.net_नूतनीकरणबाकी++;
            }

            subTotal.net_amount =
              (subTotal.net_amount || 0) + amt;

            finalTotal.net_amount =
              (finalTotal.net_amount || 0) + amt;

            subTotal.net_एकूण++;

            finalTotal.net_एकूण++;
          }

          if (!EXCLUDE_YOJANA.includes(subType)) {

            if (isFuture) {

              if (record.rcpt_type === 'New') {

                subTotal.yojana_नवीन++;

                finalTotal.yojana_नवीन++;

              } else {

                subTotal.yojana_नूतनीकरण++;

                finalTotal.yojana_नूतनीकरण++;
              }

            } else {

              subTotal.yojana_नूतनीकरणबाकी++;

              finalTotal.yojana_नूतनीकरणबाकी++;
            }

            subTotal.yojana_amount =
              (subTotal.yojana_amount || 0) + amt;

            finalTotal.yojana_amount =
              (finalTotal.yojana_amount || 0) + amt;

            subTotal.yojana_एकूण++;

            finalTotal.yojana_एकूण++;
          }

          if (
            key &&
            subType !== DEPOSIT_TYPE
          ) {

            if (isFuture) {

              if (record.rcpt_type === 'New') {

                subTotal[key + '_नवीन']++;

                finalTotal[key + '_नवीन']++;

              } else {

                subTotal[key + '_नूतनीकरण']++;

                finalTotal[key + '_नूतनीकरण']++;
              }

            } else {

              subTotal[key + '_नूतनीकरणबाकी']++;

              finalTotal[key + '_नूतनीकरणबाकी']++;
            }

            subTotal[key + '_एकूण'] =
              (subTotal[key + '_एकूण'] || 0) + amt;

            finalTotal[key + '_एकूण'] =
              (finalTotal[key + '_एकूण'] || 0) + amt;
          }

          if (subType !== DEPOSIT_TYPE) {

            if (isFuture) {

              if (record.rcpt_type === 'New') {

                subTotal['नवीन']++;

                finalTotal['नवीन']++;

              } else {

                subTotal['नूतनीकरण']++;

                finalTotal['नूतनीकरण']++;
              }

            } else {

              subTotal['नूतनीकरणबाकी']++;

              finalTotal['नूतनीकरणबाकी']++;
            }

            subTotal['एकूण'] =
              (subTotal['एकूण'] || 0) + amt;

            finalTotal['एकूण'] =
              (finalTotal['एकूण'] || 0) + amt;
          }
        }

        subTotal['एकूण_संख्या'] =
          subTotal['नवीन'] +
          subTotal['नूतनीकरण'];

        finalTotal['एकूण_संख्या'] =
          (finalTotal['एकूण_संख्या'] || 0) +
          subTotal['एकूण_संख्या'];

        finalTotal['देणगी'] +=
          subTotal['देणगी'];

        finalTotal['देणगी_amount'] +=
          subTotal['देणगी_amount'];

        finalTotal['pending_amount'] +=
          subTotal['pending_amount'];

        officeGroup.push(subTotal);
      }
    }

    this.finalData.push(officeGroup);
  }

  finalTotal['row_total'] =
    (finalTotal['एकूण'] || 0) +
    (finalTotal['net_amount'] || 0) +
    (finalTotal['yojana_amount'] || 0) +
    (finalTotal['देणगी_amount'] || 0) +
    (finalTotal['pending_amount'] || 0);

  this.finalData.push(finalTotal);

  this.isLoading = false;
}

 
   exportExcel(fileName) {
     /* table id is passed over here */
     let element = document.getElementById('print-section');
     const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
 
     /* generate workbook and add the worksheet */
     const wb: XLSX.WorkBook = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
     /* save to file */
     XLSX.writeFile(wb, fileName + '.xlsx');
   }
 
 
   //Main Report Method Use in all Printing Page
   show = false
  //  printPage() {
  //    this.show = true
  //    const printContent = document.getElementById('print-section')?.outerHTML;
  //    if (!printContent) {
  //      console.error("Print section not found!");
  //      return;
  //    }
 
  //    const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');
 
  //    if (printWindow) {
  //      printWindow.document.open();
  //      printWindow.document.write(`
  //             <html>
  //                 <head>
  //                     <title>Print Report</title>
  //                     <style>
  //                         @media print {
  //                             @page { 
  //                                 size: A3 landscape; /* Set A3 size with landscape mode */
  //                                 margin: 5mm; /* Adjust margins */
  //                             }
  //                             body { 
  //                                 font-family: Arial, sans-serif; 
  //                                 font-size: 15px; /* Adjust font size */
  //                                 margin: 0; 
  //                                 padding: 5mm; 
  //                                 line-height: 1.2; 
  //                             }
  //                             table { 
  //                                 width: 100%; 
  //                                 height: 100%;
  //                                 border-collapse: collapse; 
  //                                 table-layout: fixed; /* Prevent column expansion */
  //                                 page-break-inside: avoid; /* Avoid breaking the table */
  //                             }
  //                             th, td { 
  //                                 padding: 2px; 
  //                                 border: 1px solid black; 
  //                                 text-align: center; 
  //                                 font-size: 12px; /* Adjusted font size */
  //                                 line-height: 1.2; 
  //                             }
  //                             .noPrint { 
  //                                 display: none; /* Hide print button */
  //                             }
  //                         }
  //                     </style>
  //                 </head>
  //                 <body>
  //                     <div id="print-section">
  //                         ${printContent}
  //                     </div>
  //                     <script>
  //                         window.onload = function() { 
  //                             window.print(); 
  //                             setTimeout(() => { window.close(); }, 500);
  //                         };
  //                     </script>
  //                 </body>
  //             </html>
  //         `);
  //      printWindow.document.close();
  //    } else {
  //      console.error("Failed to open print window.");
  //    }
  //  }


   printPage() {
  this.show = true;

  const printContent = document.getElementById('print-section')?.outerHTML;
  if (!printContent) {
    console.error("Print section not found!");
    return;
  }

  const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

  if (printWindow) {
    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Report</title>
          <style>
            @media print {
              @page { 
                size: A3 landscape;
                margin: 5mm;
              }

               * {
                color: black !important; /* ✅ FORCE ALL TEXT BLACK */
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }

              body { 
                font-family: Arial, sans-serif; 
                font-size: 13px;
                margin: 0; 
                padding: 5mm; 
                line-height: 1.2; 
                color: black !important;
              }

              table { 
                width: 100%; 
                border-collapse: collapse; 
                table-layout: auto; /* ✅ FIX: allow flexible width */
              }

              th, td { 
                padding: 3px; 
                border: 1px solid black; 
                text-align: center; 
                font-size: 11px;
                line-height: 1.2;
                white-space: nowrap; /* ✅ prevent breaking */
                color: black !important;
              }

              th {
                font-weight: bold;
                white-space: normal; /* ✅ allow header wrap properly */
                word-break: break-word; /* ✅ clean wrap */
              }

              tr {
                page-break-inside: avoid; /* ✅ avoid row breaking */
              }

              thead {
                display: table-header-group; /* ✅ repeat header on next page */
              }

              tfoot {
                display: table-footer-group;
              }

              .largeHeading {
                font-size: 14px !important;
                white-space: normal !important; /* ✅ fix long heading */
                word-break: break-word;
              }

              .smallHeading {
                font-size: 12px !important;
                font-weight: bold;
              }

              .noPrint { 
                display: none;
              }
            }
          </style>
        </head>

        <body>
          <div id="print-section">
            ${printContent}
          </div>

          <script>
            window.onload = function() { 
              window.print(); 
              setTimeout(() => { window.close(); }, 500);
            };
          </script>
        </body>
      </html>
    `);

    printWindow.document.close();
  } else {
    console.error("Failed to open print window.");
  }
}
 


}
